module.exports = __webpack_public_path__ + "7c967f820cc692a7470bededad1fc630.jpg";